import { withInstall } from '../../utils/with-install.mjs';
import './src/icon2.mjs';
export { iconProps } from './src/icon.mjs';
import script from './src/icon.vue_vue_type_script_lang.mjs';

const ElIcon = withInstall(script);

export { ElIcon, ElIcon as default };
//# sourceMappingURL=index.mjs.map
